import * as React from "react";
const SvgMenu24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 14,
        fill: "black",
        viewBox: "0 0 18 14"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M18 2H0V0h18v2Zm0 6H0V6h18v2ZM0 14h18v-2H0v2Z",
      clipRule: "evenodd"
    })
  );
export default SvgMenu24Px;
